// extracted by mini-css-extract-plugin
export var searchBoxRoot = "SearchBox-module--searchBoxRoot--3ofWt";
export var searchBoxContent = "SearchBox-module--searchBoxContent--2MhvG";
export var searchBoxTitle = "SearchBox-module--searchBoxTitle--1dBQ3";
export var searchBoxTitleIcon = "SearchBox-module--searchBoxTitleIcon--s2L3O";